module.exports = __webpack_public_path__ + "img/OK_blue.850c78ff.svg";